import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import toast from "react-hot-toast";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import { Button, Tag, Badge, Drawer, Spin } from "antd";
import {
  EyeOutlined,
  FilePdfOutlined,
  ShoppingOutlined,
  UndoOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  InfoCircleOutlined,
  UpOutlined,
  DownOutlined, LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined
} from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import { get_supplier_purchase_report } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import UserCurrency from "../../../Componets/UserCurrency";
import getCountryCurrencyCode from "../../../Main/getCountryCurrencyCode";

const SupplierPurchaseReport = () => {
  const [loader, setLoader] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [summary, setSummary] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [transactionType, setTransactionType] = useState("all");
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState({});
  const componentRef = useRef();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [supplierPOSummary, setSupplierPOSummary] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [currencyCode, setCurrencyCode] = useState("");

  useEffect(() => {
    const fetchCurrency = async () => {
      const code = await getCountryCurrencyCode();
      setCurrencyCode(code);
    };

    fetchCurrency();
  }, []);


  const headers = {
    name: "Supplier Product Transactions Report",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search product or supplier...",
        value: "",
      },
      {
        type: "filter",
        name: "supplier",
        placeholder: "Supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        placeholder: "Transaction Date Range",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "filter",
        name: "branch",
        placeholder: "Branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "select",
        name: "transactionType",
        placeholder: "Transaction Type",
        value: "all",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "all", label: "All Transactions" },
          { value: "purchase", label: "Purchases Only" },
          { value: "return", label: "Returns Only" },
        ],
      },
      {
        type: "select",
        name: "paymentStatus",
        placeholder: "Payment Status",
        value: "all",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "all", label: "All Payment Status" },
          { value: "paid", label: "Paid" },
          { value: "partial", label: "Partial" },
          { value: "unpaid", label: "Unpaid" },
        ],
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Supplier Product Transactions",
          path: "",
        },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const fetchReport = async (filters = {}, page = 1) => {
    try {
      setLoader(true);

      const params = {
        search: filters.search || "",
        supplier: filters.supplier || null,
        date: filters.date || {},
        branch: filters.branch || null,
        transactionType: filters.transactionType || transactionType,
        paymentStatus: filters.paymentStatus || "all",
        page: page,
        limit: 50,
      };

      console.log("Fetching with params:", params);

      const response = await get_supplier_purchase_report(params);

      if (response?.status) {
        console.log("API Response data:", response.data.data);
        setReportData(response.data.data || []);
        setSummary(response.data.summary || {});
        setPagination(response.data.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalCount: 0,
          pageSize: 50,
        });
      } else {
        toast.error(response?.message || "Failed to fetch report");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const handleShowPOSummary = () => {
    setDrawerVisible(true);
    if (supplierPOSummary.length === 0) {
      loadSupplierPOSummary();
    }
  };

  const formdata = (data) => {
    let processedData = { ...data };

    // Handle supplier object
    if (data.supplier && typeof data.supplier === "object") {
      processedData.supplier = data.supplier._id || data.supplier.id;
    }

    // Update transactionType if changed
    if (data.transactionType !== undefined && data.transactionType !== transactionType) {
      setTransactionType(data.transactionType);
    }

    // Update header state with new values
    setHeader(prev => ({
      ...prev,
      components: prev.components.map(comp => ({
        ...comp,
        value: data[comp.name] !== undefined ? data[comp.name] : comp.value
      }))
    }));

    // Reset and fetch
    setExpandedRows({});
    setSupplierPOSummary([]);
    fetchReport(processedData, 1);
  };

  const fetchAllTransactions = async () => {
    try {
      setLoader(true); // Show loader while fetching all data
      const headerdata = {};
      header.components.forEach((value) => {
        headerdata[value.name] = value.value;
      });

      const params = {
        search: headerdata.search || "",
        supplier: headerdata.supplier || null,
        date: headerdata.date || {},
        branch: headerdata.branch || null,
        transactionType: headerdata.transactionType || transactionType,
        limit: 10000,
        source: "Export_Report"
      };

      const response = await get_supplier_purchase_report(params);
      return response?.status ? response.data.data : [];
    } catch (error) {
      toast.error("Failed to fetch full report for download");
      return [];
    } finally {
      setLoader(false);
    }
  };

  const loadSupplierPOSummary = async () => {
    try {
      setLoadingSummary(true);
      const headerdata = {};
      header.components.forEach((comp) => {
        headerdata[comp.name] = comp.value;
      });
      const params = {
        search: headerdata.search,
        supplier: headerdata.supplier,
        date: headerdata.date,
        branch: headerdata.branch,
        transactionType: headerdata.transactionType || transactionType,
        paymentStatus: 'all',
        groupBy: 'po',
        limit: 10000,
      };
      const response = await get_supplier_purchase_report(params);
      if (response?.status) {
        setSupplierPOSummary(response.data.data || []);
      } else {
        toast.error(response?.message || 'Failed to load summary');
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoadingSummary(false);
    }
  };

  const downloadPOSummaryPDF = () => {
    if (!supplierPOSummary.length) {
      toast.error("No PO summary data to export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFontSize(16);
    doc.text("Supplier / PO Payment Summary", pageWidth / 2, 15, { align: "center" });

    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, pageWidth / 2, 22, { align: "center" });

    // Prepare table rows
    const tableRows = supplierPOSummary.map((row) => [
      row.supplier.name,
      `#${row.poNumber}`,
      row.finalStatus,
      (row.paid || 0).toFixed(3),
      (row.unpaid || 0).toFixed(3),
      (row.total || 0).toFixed(3),
    ]);

    // Calculate totals
    const totals = supplierPOSummary.reduce(
      (acc, row) => {
        acc.paid += row.paid || 0;
        acc.unpaid += row.unpaid || 0;
        acc.total += row.total || 0;
        return acc;
      },
      { paid: 0, unpaid: 0, total: 0 }
    );

    // Add totals row
    tableRows.push([
      "TOTALS",
      "",
      "",
      totals.paid.toFixed(3),
      totals.unpaid.toFixed(3),
      totals.total.toFixed(3),
    ]);

    autoTable(doc, {
      startY: 30,
      head: [["Supplier", "PO Number", "Payment Status", `Paid (${currencyCode})`, `Unpaid (${currencyCode})`, `Total (${currencyCode})`]],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      styles: {
        fontSize: 9,
        cellPadding: 2,
      },
      didParseCell: (data) => {
        if (data.row.index === supplierPOSummary.length) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },
    });

    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const handleFirst = () => {
    if (pagination?.currentPage > 1) {
      handlePageChange(1);
    }
  };

  const handleLast = () => {
    if (pagination?.currentPage < pagination?.totalPages) {
      handlePageChange(pagination?.totalPages);
    }
  };

  const handlePrevious = () => {
    if (pagination?.currentPage > 1) {
      handlePageChange(pagination?.currentPage - 1);
    }
  };

  const handleNext = () => {
    if (pagination?.currentPage < pagination?.totalPages) {
      handlePageChange(pagination?.currentPage + 1);
    }
  };

  const generatePageNumbers = () => {
    const currentPage = pagination?.currentPage || 1;
    const totalPages = pagination?.totalPages || 1;
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const handlePageChange = (page) => {
    const filters = {};
    headers.components.forEach((comp) => {
      const componentValue = header.components.find((c) => c.name === comp.name)?.value;
      if (componentValue !== undefined && componentValue !== null && componentValue !== "") {
        filters[comp.name] = componentValue;
      }
    });
    filters.transactionType = transactionType;

    // Reset expanded rows when changing page
    setExpandedRows({});

    fetchReport(filters, page);
  };

  const toggleRowExpand = (item) => {
    const key = `${item.supplier.id}-${item.product.id}`;
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getNetPositionTag = (item) => {
    if (item.netPosition?.isNetPositive && transactionType !== "return") {
      return (
        <Tag color="green" className="ml-2">
          Net Purchase: {item.netPosition.netQuantity}
        </Tag>
      );
    } else if (
      (item.netPosition?.netQuantity < 0 || transactionType === "return") &&
      transactionType !== "purchase"
    ) {
      return (
        <Tag color="red" className="ml-2">
          Net Return: {Math.abs(item.netPosition?.netQuantity || 0)}
        </Tag>
      );
    }
    return null;
  };

  // Function to get payment tag color for individual transactions
  const getPaymentTagColor = (status) => {
    switch (status?.toLowerCase()) {
      case "paid":
        return "green";
      case "partial":
        return "orange";
      case "unpaid":
        return "red";
      default:
        return "default";
    }
  };

  const downloadCSV = () => {
    if (!reportData.length) {
      toast.error("No data to export");
      return;
    }

    // Collect and filter transactions
    const allTransactions = reportData.flatMap((item) =>
      (item.batchDetails || [])
        .filter(
          (batch) =>
            transactionType === "all" ||
            (transactionType === "purchase" &&
              batch.transactionType === "purchase") ||
            (transactionType === "return" &&
              batch.transactionType === "return"),
        )
        .map((batch) => {
          const isReturn = batch.transactionType === "return";
          const sign = isReturn ? -1 : 1;

          return {
            supplier: item.supplier.name,
            poNumber: batch.purchaseNumber,
            date: formatDateDDMMYYYY(batch.date),
            product: item.product.name,
            unit: item.product.unit || "N/A",
            batch: batch.batch || "N/A",
            quantity: sign * Math.abs(batch.totalQty || 0),
            price: Math.abs(batch.unitPrice || 0),
            total: sign * Math.abs(batch.lineTotal || 0),
            transactionType: batch.transactionType,
            paymentStatus:
              batch.paymentStatus || (isReturn ? "N/A" : "unknown"),
          };
        }),
    );

    if (allTransactions.length === 0) {
      toast.error("No transaction data to export");
      return;
    }

    // Separate purchase and return transactions
    const purchaseTransactions = allTransactions.filter(
      (t) => t.transactionType === "purchase",
    );
    const returnTransactions = allTransactions.filter(
      (t) => t.transactionType === "return",
    );

    // Calculate totals
    const totalPurchaseQty = purchaseTransactions.reduce(
      (sum, t) => sum + t.quantity,
      0,
    );
    const totalReturnQty = returnTransactions.reduce(
      (sum, t) => sum + t.quantity,
      0,
    );
    const netQty = totalPurchaseQty + totalReturnQty;

    const totalPurchaseAmount = purchaseTransactions.reduce(
      (sum, t) => sum + t.total,
      0,
    );
    const totalReturnAmount = returnTransactions.reduce(
      (sum, t) => sum + t.total,
      0,
    );
    const netAmount = totalPurchaseAmount + totalReturnAmount;

    // Headers
    const headers = [
      "S.no",
      "Supplier",
      "Transaction Type",
      "PO",
      "Date",
      "Product",
      "Unit",
      "Batch",
      "Qty",
      `Price (${currencyCode})`,
      `Total (${currencyCode})`,
    ];

    if (transactionType !== "return") headers.push("Payment Status");

    // Transaction rows
    const transactionRows = allTransactions.map((t, i) => [
      i + 1,
      `"${t.supplier}"`,
      t.transactionType === "purchase" ? "Purchase" : "Return",
      `"${t.poNumber}"`,
      t.date,
      `"${t.product}"`,
      t.unit,
      `"${t.batch}"`,
      t.quantity,
      t.price.toFixed(3),
      t.transactionType === "return"
        ? `-${Math.abs(t.total).toFixed(3)}`
        : t.total.toFixed(3),
      ...(transactionType !== "return"
        ? [t.transactionType === "purchase" ? t.paymentStatus : "N/A"]
        : []),
    ]);

    // Add empty line before summary
    transactionRows.push(Array(headers.length).fill(""));

    // Summary rows
    const summaryRows = [];

    if (purchaseTransactions.length > 0) {
      summaryRows.push([
        "",
        "PURCHASES TOTAL",
        "",
        "",
        "",
        "",
        "",
        "",
        totalPurchaseQty,
        "",
        totalPurchaseAmount.toFixed(3),
        ...(transactionType !== "return" ? [""] : []),
      ]);
    }

    if (returnTransactions.length > 0) {
      summaryRows.push([
        "",
        "RETURNS TOTAL",
        "",
        "",
        "",
        "",
        "",
        "",
        totalReturnQty,
        "",
        totalReturnAmount.toFixed(3),
        ...(transactionType !== "return" ? [""] : []),
      ]);
    }

    summaryRows.push([
      "",
      "NET TOTAL",
      "",
      "",
      "",
      "",
      "",
      "",
      netQty,
      "",
      netAmount.toFixed(3),
      ...(transactionType !== "return" ? [""] : []),
    ]);

    // Combine everything
    const rows = [...transactionRows, ...summaryRows];
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    // Download
    const blob = new Blob(["\uFEFF" + csvContent], {
      type: "text/csv;charset=utf-8",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    const filename = `Supplier_${transactionType === "purchase"
      ? "Purchases"
      : transactionType === "return"
        ? "Returns"
        : "Transactions"
      }_${new Date().toISOString().split("T")[0]}.csv`;

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const downloadPDF = async () => {
    try {
      const allData = await fetchAllTransactions(); // Fetch full dataset

      if (!allData || allData.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFontSize(16);
      doc.text("Supplier Product Transactions Report", pageWidth / 2, 15, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, pageWidth / 2, 22, { align: "center" });

      // Flatten data for the table
      const tableRows = [];
      let totalPurchaseValue = 0;
      let totalReturnValue = 0;
      let totalPurchaseQty = 0;
      let totalReturnQty = 0;

      allData.forEach((item) => {
        (item.batchDetails || []).forEach((batch) => {
          const isReturn = batch.transactionType === "return";
          const qty = Math.abs(batch.totalQty || 0);
          const total = Math.abs(batch.lineTotal || 0);

          if (isReturn) {
            totalReturnQty += qty;
            totalReturnValue += total;
          } else {
            totalPurchaseQty += qty;
            totalPurchaseValue += total;
          }

          tableRows.push([
            tableRows.length + 1,
            item.supplier.name,
            item.product.name,
            batch.transactionType.toUpperCase(),
            formatDateDDMMYYYY(batch.date),
            `#${batch.purchaseNumber}`,
            batch.batch || "N/A",
            qty.toLocaleString(),
            batch.unitPrice.toFixed(3),
            isReturn ? `-${total.toFixed(3)}` : total.toFixed(3),
          ]);
        });
      });

      // 1. Transactions Table
      autoTable(doc, {
        startY: 30,
        head: [["S.No", "Supplier", "Product", "Type", "Date", "PO#", "Batch", "Qty", "Price", `Total (${currencyCode})`]],
        body: tableRows,
        theme: "grid",
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.3,
          lineColor: [40, 40, 40] // Dark border
        },
        bodyStyles: {
          textColor: [0, 0, 0], // Darker text (almost black)
          lineWidth: 0.2,
          lineColor: [80, 80, 80] // Darker borders
        },
        styles: {
          fontSize: 7,
          cellPadding: 2
        },
        didParseCell: (data) => {
          if (data.section === 'body' && data.column.index === 3) {
            if (data.cell.raw === 'RETURN') data.cell.styles.textColor = [200, 0, 0]; // Darker red for returns
          }
        },
        margin: { top: 30 }
      });

      // 2. Summary Table (positioned after the first table) - DARKER STYLES
      const finalY = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("Summary Report", 14, finalY);

      autoTable(doc, {
        startY: finalY + 5,
        body: [
          ["Total Purchases", totalPurchaseQty.toLocaleString(), `${currencyCode} ${totalPurchaseValue.toFixed(3)}`],
          ["Total Returns", totalReturnQty.toLocaleString(), `${currencyCode} ${totalReturnValue.toFixed(3)}`],
          ["Net Total", (totalPurchaseQty - totalReturnQty).toLocaleString(), `${currencyCode} ${(totalPurchaseValue - totalReturnValue).toFixed(3)}`],
        ],
        styles: {
          fontSize: 10,
          fontStyle: 'bold',
          textColor: [30, 30, 30], // Darker text
          lineWidth: 0.3,
          lineColor: [80, 80, 80] // Darker borders
        },
        columnStyles: {
          0: {
            cellWidth: 50,
            fillColor: [240, 240, 240] // Slightly darker background for first column
          },
          1: {
            halign: 'right',
            fillColor: [245, 245, 245]
          },
          2: {
            halign: 'right',
            fillColor: [245, 245, 245]
          }
        },
        head: false, // No header for summary table
        theme: 'grid' // Changed from 'plain' to 'grid' for borders
      });

      window.open(URL.createObjectURL(doc.output("blob")));
    } catch (error) {
      console.error("PDF Error:", error);
      toast.error("Failed to generate PDF");
    }
  };

  const renderTransactionDetails = (item) => {
    if (
      !item.batchDetails ||
      !expandedRows[`${item.supplier.id}-${item.product.id}`]
    ) {
      return null;
    }

    // Filter batch details based on transaction type
    let filteredBatchDetails = item.batchDetails;
    if (transactionType === "return") {
      filteredBatchDetails = item.batchDetails.filter(
        (b) => b.transactionType === "return",
      );
    } else if (transactionType === "purchase") {
      filteredBatchDetails = item.batchDetails.filter(
        (b) => b.transactionType === "purchase",
      );
    }

    if (filteredBatchDetails.length === 0) {
      return null;
    }

    const purchases = filteredBatchDetails.filter(
      (b) => b.transactionType === "purchase",
    );
    const returns = filteredBatchDetails.filter(
      (b) => b.transactionType === "return",
    );

    const totalPurchaseQty = purchases.reduce(
      (sum, p) => sum + (p.totalQty || 0),
      0,
    );
    const totalReturnQty = Math.abs(
      returns.reduce((sum, r) => sum + (r.totalQty || 0), 0),
    );
    const totalPurchaseValue = purchases.reduce(
      (sum, p) => sum + (p.lineTotal || 0),
      0,
    );
    const totalReturnValue = Math.abs(
      returns.reduce((sum, r) => sum + (r.lineTotal || 0), 0),
    );

    return (
      <tr className="bg-gray-50">
        <td colSpan="10" className="border p-0">
          <div className="p-4">
            {/* Transaction Details Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-sm bg-white border rounded-lg shadow-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">Type</th>
                    <th className="p-2 border">Batch/Barcode</th>
                    <th className="p-2 border">Date</th>
                    <th className="p-2 border">PO#</th>
                    <th className="p-2 border">Ordered</th>
                    <th className="p-2 border">FOC</th>
                    <th className="p-2 border">Total Qty</th>
                    <th className="p-2 border">Purchase price</th>
                    <th className="p-2 border">Payment Status</th>
                    <th className="p-2 border">Tax %</th>
                    <th className="p-2 border">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBatchDetails.map((batch, batchIndex) => {
                    const isReturn = batch.transactionType === "return";
                    const displayQty = Math.abs(batch.totalQty || 0);
                    const displayOrdered = Math.abs(batch.ordered || 0);
                    const displayFOC = Math.abs(batch.foc || 0);
                    const displayTotal = Math.abs(batch.lineTotal || 0);
                    const paymentStatus =
                      batch.paymentStatus?.toLowerCase() || "unknown";

                    return (
                      <tr
                        key={batchIndex}
                        className={`hover:bg-gray-50 border-t ${isReturn ? "bg-red-50" : ""}`}
                      >
                        <td className="p-2 border text-center">
                          {isReturn ? (
                            <Tag color="red" className="!m-0 text-xs">
                              Return
                            </Tag>
                          ) : (
                            <Tag color="green" className="!m-0 text-xs">
                              Purchase
                            </Tag>
                          )}
                        </td>

                        <td className="p-2 border text-center font-mono text-xs">
                          {batch.batch || "N/A"}
                        </td>
                        <td className="p-2 border text-center">
                          {formatDateDDMMYYYY(batch.date)}
                        </td>
                        <td className="p-2 border text-center font-medium">
                          #{batch.purchaseNumber}
                        </td>
                        <td
                          className={`p-2 border text-right ${isReturn ? "text-red-600" : ""}`}
                        >
                          {displayOrdered.toLocaleString()}
                        </td>
                        <td
                          className={`p-2 border text-right ${isReturn ? "text-red-600" : ""}`}
                        >
                          <span
                            className={batch.foc !== 0 ? "font-medium" : ""}
                          >
                            {displayFOC.toLocaleString()}
                          </span>
                        </td>
                        <td
                          className={`p-2 border text-right ${isReturn ? "text-red-600" : ""}`}
                        >
                          {displayQty.toLocaleString()}
                        </td>
                        <td className="p-2 border text-right">
                          <UserCurrency />{" "}
                          {Math.abs(batch.unitPrice || 0)?.toFixed(3) ||
                            "0.000"}
                        </td>

                        <td className="p-2 border text-center">
                          {!isReturn ? (
                            <Tag
                              color={getPaymentTagColor(paymentStatus)}
                              className="!m-0 text-xs"
                            >
                              {batch.paymentStatus?.charAt(0).toUpperCase() +
                                batch.paymentStatus?.slice(1) || "N/A"}
                            </Tag>
                          ) : (
                            <span className="text-gray-400 text-xs">N/A</span>
                          )}
                        </td>
                        <td className="p-2 border text-right">
                          {batch.tax?.rate > 0 ? (
                            <span className="font-medium">{batch.tax?.rate}%</span>
                          ) : (
                            <span className="text-gray-400">0%</span>
                          )}
                        </td>
                        <td
                          className={`p-2 border text-right ${isReturn ? "text-red-600" : ""}`}
                        >
                          {isReturn ? `-${currencyCode} ` : `${currencyCode} `}
                          {displayTotal.toFixed(3)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot className="bg-gray-100">
                  <tr>
                    <td
                      className="p-2 border text-right font-semibold"
                      colSpan="6"
                    >
                      {transactionType === "all" ? "NET IMPACT:" : "TOTALS:"}
                    </td>
                    <td className="p-2 border text-right font-semibold">
                      {filteredBatchDetails
                        .reduce((sum, b) => {
                          const qty = Math.abs(b.totalQty || 0);
                          return b.transactionType === "return"
                            ? sum - qty
                            : sum + qty;
                        }, 0)
                        .toLocaleString()}
                    </td>
                    <td className="p-2 border"></td>
                    <td className="p-2 border"></td>
                    <td className="p-2 border"></td>
                    <td
                      className={`p-2 border text-right font-semibold ${item.totals.spent < 0 ? "text-red-600" : ""}`}
                    >
                      {item.totals.spent < 0 ? `-${currencyCode} ` : `${currencyCode} `}
                      {Math.abs(item.totals.spent)?.toFixed(3) || 0}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  useEffect(() => {
    fetchReport({}, 1);
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="flex flex-col h-[calc(100vh-220px)]">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 mt-2">
            <div className="bg-white p-4 rounded-lg shadow-sm border">
              <h3 className="text-sm text-gray-600 mb-1">
                {transactionType === "return"
                  ? "Credit from Returns"
                  : "Net Spent"}
              </h3>
              <p
                className={`text-2xl font-semibold ${(summary.totalSpent || 0) < 0 ? "text-red-600" : "text-gray-800"}`}
              >
                {transactionType === "return" ? `-${currencyCode} ` : `${currencyCode} `}
                {Math.abs(summary.totalSpent || 0)?.toFixed(3) || 0}
              </p>
              <div className="flex justify-between text-xs text-gray-500 mt-1">
                {transactionType === "all" && (
                  <>
                    <span>
                      Purchases: <UserCurrency /> {summary.totalPurchaseValue?.toFixed(3) || 0}
                    </span>
                    <span className="text-red-600">
                      Returns: -<UserCurrency /> {summary.totalReturnValue?.toFixed(3) || 0}
                    </span>
                  </>
                )}
              </div>
              {/* Add this line for pagination info */}
              <div className="text-xs text-gray-400 mt-1">
                Page {pagination.currentPage || 1} of {pagination.totalPages || 1}
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg shadow-sm border">
              <h3 className="text-sm text-gray-600 mb-1">
                {transactionType === "return"
                  ? "Total Returned Qty"
                  : "Net Quantity"}
              </h3>
              <p
                className={`text-2xl font-semibold ${(summary.totalEffectiveQty || 0) < 0 ? "text-red-600" : "text-gray-800"}`}
              >
                {transactionType === "return" ? "-" : ""}
                {Math.abs(summary.totalEffectiveQty || 0)?.toLocaleString() || 0}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {transactionType === "return"
                  ? "Total quantity returned"
                  : "Net qty across all products"}
              </p>
            </div>

            <div className="bg-white p-4 rounded-lg shadow-sm border">
              <h3 className="text-sm text-gray-600 mb-1">Total Transactions</h3>
              <p className="text-2xl font-semibold text-gray-800">
                {summary.totalTransactions || 0}
              </p>
              <div className="flex justify-between text-xs text-gray-500 mt-1">
                {transactionType === "all" ? (
                  <>
                    <span>Purchases: {summary.totalPurchases || 0}</span>
                    <span className="text-red-600">
                      Returns: {summary.totalReturns || 0}
                    </span>
                  </>
                ) : transactionType === "return" ? (
                  <span className="text-red-600">
                    Return Transactions: {summary.totalReturns || 0}
                  </span>
                ) : (
                  <span className="text-green-600">
                    Purchase Transactions: {summary.totalPurchases || 0}
                  </span>
                )}
              </div>
            </div>

            {/* NEW PAYMENT STATUS SUMMARY CARD */}
            <div className="bg-white p-4 rounded-lg shadow-sm border">
              <h3 className="text-sm text-gray-600 mb-2">Payment Status</h3>

              <div className="flex flex-col gap-1 text-xs text-gray-600">
                <div className="flex justify-between">
                  <span className="text-green-600">Paid</span>
                  <span>{summary.totalPaid || 0}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-orange-500">Partial</span>
                  <span>{summary.totalPartial || 0}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-red-600">Unpaid</span>
                  <span>{summary.totalUnpaid || 0}</span>
                </div>
              </div>
            </div>
          </div>
          <Drawer
            title="Supplier / PO Payment Summary"
            placement="right"
            width="45%"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            bodyStyle={{ padding: '16px' }}
            extra={
              <Button
                type="primary"
                icon={<FilePdfOutlined />}
                onClick={downloadPOSummaryPDF}
                disabled={!supplierPOSummary.length || loadingSummary}
              >
                Export PDF
              </Button>
            }
          >
            {loadingSummary ? (
              <div className="text-center py-4"><Spin /></div>
            ) : supplierPOSummary.length === 0 ? (
              <div className="text-center py-4 text-gray-500">No summary data available</div>
            ) : (
              <div className="overflow-x-auto border rounded-lg">
                <table className="w-full text-sm bg-white">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">Supplier</th>
                      <th className="border p-2">PO Number</th>
                      <th className="border p-2">Payment Status</th>
                      <th className="border p-2 text-right">Paid (<UserCurrency />)</th>
                      <th className="border p-2 text-right">Unpaid (<UserCurrency />)</th>
                      <th className="border p-2 text-right">Total (<UserCurrency />)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supplierPOSummary.map((row, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="border p-2">{row.supplier.name}</td>
                        <td className="border p-2 font-mono">#{row.poNumber}</td>
                        <td className="border p-2">
                          <Tag color={
                            row.finalStatus === 'paid' ? 'green' :
                              row.finalStatus === 'unpaid' ? 'red' :
                                row.finalStatus === 'partial' ? 'orange' : 'default'
                          }>
                            {row.finalStatus}
                          </Tag>
                        </td>
                        <td className="border p-2 text-right">{(row.paid || 0).toFixed(3)}</td>
                        <td className="border p-2 text-right">{(row.unpaid || 0).toFixed(3)}</td>
                        <td className="border p-2 text-right font-semibold">{(row.total || 0).toFixed(3)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-gray-50">
                    <tr>
                      <td colSpan="3" className="border p-2 text-right font-semibold">Totals</td>
                      <td className="border p-2 text-right">
                        {supplierPOSummary.reduce((sum, r) => (sum + (r.paid || 0)), 0).toFixed(3)}
                      </td>
                      <td className="border p-2 text-right">
                        {supplierPOSummary.reduce((sum, r) => (sum + (r.unpaid || 0)), 0).toFixed(3)}
                      </td>
                      <td className="border p-2 text-right">
                        {supplierPOSummary.reduce((sum, r) => (sum + (r.total || 0)), 0).toFixed(3)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </Drawer>

          {/* Export Buttons */}
          <div className="flex justify-between items-center mb-4">
            <div className="text-sm text-gray-600">
              {transactionType !== "all" && (
                <Tag
                  color={transactionType === "purchase" ? "green" : "red"}
                  className="ml-2"
                >
                  {transactionType === "purchase"
                    ? "Purchases Only"
                    : "Returns Only"}
                </Tag>
              )}
              {transactionType === "return" && (
                <span className="ml-2 text-red-600">
                  Total Credit: <UserCurrency /> {Math.abs(summary.totalSpent || 0).toFixed(3)}
                </span>
              )}
            </div>
            <div className="flex gap-3">
              <Button
                onClick={handleShowPOSummary}
                className="!bg-blue-500 !border-blue-500 hover:!bg-blue-600"
                type="primary"
              >
                Show PO Summary
              </Button>
              <Button
                className="mr-2  !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
                type="primary"
                onClick={downloadCSV}
              >
                Download CSV
              </Button>

              <Button
                className="mr-2 !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
                type="primary"
                icon={<FilePdfOutlined />}
                onClick={downloadPDF} // Point to the new function
              >
                Download PDF
              </Button>
            </div>
          </div>

          {/* Report Table */}
          <ScrollWrapper>
            <div className="max-h-[60vh] overflow-y-auto" ref={componentRef}>
              <table className="w-full text-sm bg-white border rounded-lg shadow-sm">
                <thead className="sticky top-0 bg-white z-10">
                  <tr>
                    <th className="border p-2 text-left">Product & Supplier</th>
                    <th className="border p-2 text-left">Batches</th>
                    <th className="border p-2 text-left">Unit</th>
                    <th className="border p-2 text-left">Net Qty</th>
                    <th className="border p-2 text-left">Price/Unit</th>
                    <th className="border p-2 text-left">Net Spent</th>
                    <th className="border p-2 text-left">Transactions</th>
                    <th className="border p-2 text-left">Last Transaction</th>
                    <th className="border p-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.map((item, index) => {
                    const key = `${item.supplier.id}-${item.product.id}`;
                    const isExpanded = expandedRows[key];
                    const isReturn =
                      transactionType === "return" ||
                      !item.netPosition?.isNetPositive;
                    const hasReturns = item.counts?.returns > 0;
                    const hasPurchases = item.counts?.purchases > 0;

                    return (
                      <React.Fragment key={key}>
                        {/* Main Consolidated Row */}
                        <tr
                          className={`hover:bg-gray-50 ${isReturn ? "bg-red-50" : ""}`}
                        >
                          <td className="border p-2">
                            <div className="flex items-center">
                              <div className="font-medium">
                                {item.product.name}
                              </div>
                              {getNetPositionTag(item)}
                            </div>
                            <div className="text-xs text-gray-500">
                              Supplier: {item.supplier.name}
                            </div>
                            <div className="flex gap-2 mt-1">
                              {transactionType !== "return" && hasPurchases && (
                                <Tag color="green" size="small">
                                  <ShoppingOutlined className="mr-1" />{" "}
                                  {item.counts.purchases}
                                </Tag>
                              )}
                              {(transactionType === "all" ||
                                transactionType === "return") &&
                                hasReturns && (
                                  <Tag color="red" size="small">
                                    <UndoOutlined className="mr-1" />{" "}
                                    {item.counts.returns}
                                  </Tag>
                                )}
                            </div>
                          </td>

                          <td className="border p-2 text-center">
                            <Tag color={isReturn ? "red" : "blue"}>
                              {item.counts.batches || 0} batch
                              {(item.counts.batches || 0) !== 1 ? "es" : ""}
                            </Tag>
                          </td>

                          <td className="border p-2 text-center">
                            {item.product.unit || "N/A"}
                          </td>

                          {/* NET QUANTITY */}
                          <td className="border p-2 text-right">
                            <div
                              className={`font-semibold text-lg ${isReturn ? "text-red-600" : "text-gray-800"}`}
                            >
                              {isReturn && transactionType === "return"
                                ? "-"
                                : ""}
                              {Math.abs(
                                item.totals.effectiveQty || 0,
                              )?.toLocaleString() || 0}
                            </div>
                            <div className="text-xs text-gray-600">
                              <span className="mr-3">
                                {isReturn && transactionType === "return"
                                  ? "Returned: "
                                  : "Ordered: "}
                                {Math.abs(item.totals.ordered || 0)}
                              </span>
                              {item.totals.foc !== 0 && (
                                <span>FOC: {Math.abs(item.totals.foc || 0)}</span>
                              )}
                            </div>
                          </td>

                          {/* EFFECTIVE PRICE */}
                          <td className="border p-2 text-right">
                            <div
                              className={`font-semibold text-lg ${isReturn ? "text-red-600" : "text-gray-800"}`}
                            >
                              {isReturn && transactionType === "return"
                                ? `-${currencyCode} `
                                : `${currencyCode} `}
                              {Math.abs(
                                item.pricing.effectivePricePerUnit || 0,
                              )?.toFixed(3) || 0}
                            </div>
                            {transactionType === "all" &&
                              item.pricing.avgPurchasePrice > 0 && (
                                <div className="text-xs text-gray-600">
                                  Purchase price: <UserCurrency />{" "}
                                  {Math.abs(
                                    item.pricing.avgPurchasePrice || 0,
                                  )?.toFixed(3) || 0}
                                </div>
                              )}
                          </td>

                          {/* NET SPENT */}
                          <td className="border p-2 text-right">
                            <div
                              className={`font-semibold text-lg ${isReturn ? "text-red-600" : "text-gray-800"}`}
                            >
                              {isReturn ? `-${currencyCode} ` : `${currencyCode} `}
                              {Math.abs(item.totals.spent || 0)?.toFixed(3) || 0}
                            </div>
                            {isReturn && (
                              <div className="text-xs text-red-600">
                                Credit from returns
                              </div>
                            )}
                          </td>

                          {/* TRANSACTIONS */}
                          <td className="border p-2 text-center">
                            <div className="font-semibold text-lg text-gray-800">
                              {(item.counts.purchases || 0) +
                                (item.counts.returns || 0)}
                            </div>
                            <div className="text-xs text-gray-600">
                              {item.counts.pos || 0} PO
                              {(item.counts.pos || 0) !== 1 ? "s" : ""}
                            </div>
                          </td>

                          {/* DATES */}
                          <td className="border p-2 text-center">
                            <div className="font-medium text-gray-800">
                              {formatDateDDMMYYYY(item.dates.last)}
                            </div>
                            <div className="text-xs text-gray-600">
                              First: {formatDateDDMMYYYY(item.dates.first)}
                            </div>
                          </td>

                          {/* ACTIONS */}
                          <td className="border p-2 text-center">
                            <Button
                              type="link"
                              icon={<EyeOutlined />}
                              onClick={() => toggleRowExpand(item)}
                              className="!p-0 !h-auto flex items-center text-blue-600"
                            >
                              {isExpanded ? (
                                <>
                                  Hide <UpOutlined className="ml-1" />
                                </>
                              ) : (
                                <>
                                  Details <DownOutlined className="ml-1" />
                                </>
                              )}
                            </Button>
                          </td>
                        </tr>

                        {/* Expanded Drill-Down Row */}
                        {renderTransactionDetails(item)}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot className="sticky bottom-0 bg-white z-10">
                  <tr>
                    <td colSpan="10" className="p-2 border">
                      <div className="flex justify-between items-center">
                        {/* Summary info */}
                        <div className="text-sm text-gray-600">
                          Showing {reportData.length} products •
                          Page {pagination.currentPage || 1} of {pagination.totalPages || 1} •
                          Total: {pagination.totalCount || 0} products
                        </div>

                        {/* Pagination Buttons */}
                        <div className="flex items-center space-x-1">
                          <button
                            onClick={handleFirst}
                            disabled={pagination?.currentPage === 1}
                            className="px-2 py-1 border rounded disabled:opacity-50"
                          >
                            <DoubleLeftOutlined />
                          </button>
                          <button
                            onClick={handlePrevious}
                            disabled={pagination?.currentPage === 1}
                            className="px-2 py-1 border rounded disabled:opacity-50"
                          >
                            <LeftOutlined />
                          </button>

                          {generatePageNumbers().map((page, i) => (
                            <button
                              key={i}
                              onClick={() => typeof page === 'number' && handlePageChange(page)}
                              disabled={page === '...'}
                              className={`px-3 py-1 rounded ${page === pagination.currentPage
                                ? "bg-[#0dacce] text-white"
                                : "hover:bg-gray-100"
                                }`}
                            >
                              {page}
                            </button>
                          ))}

                          <button
                            onClick={handleNext}
                            disabled={pagination?.currentPage === pagination?.totalPages}
                            className="px-2 py-1 border rounded disabled:opacity-50"
                          >
                            <RightOutlined />
                          </button>
                          <button
                            onClick={handleLast}
                            disabled={pagination?.currentPage === pagination?.totalPages}
                            className="px-2 py-1 border rounded disabled:opacity-50"
                          >
                            <DoubleRightOutlined />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tfoot>

              </table>
            </div>
          </ScrollWrapper>

          {/* No Data State */}
          {!loader && reportData.length === 0 && (
            <div className="text-center py-12">
              <div className="text-gray-400 text-lg mb-2">
                No transaction data found
              </div>
              <p className="text-gray-500 text-sm">
                Try adjusting your filters or date range
              </p>
            </div>
          )}
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default SupplierPurchaseReport;